<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ded"></a></p>
<div class="ctag1"><b>FOR JAMES CAMERON,<br/> master of his trade</b></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// stud_9781595587596_oeb_ded_r1.vue?6999259f